export default class StackSlider {
        
    cache;
    container;
    spans;
    transform = "translate3d({y}vh, 0,-{z}vh)";
    colorstep;
    currentIndex = 1;
    slideIndex = 1;

    constructor() {
        this.spans = [];
        this.container = document.getElementById("container");

        if (this.ifElementExists(this.container)) {
            this.spans = this.container.children;
            this.transform = "translate3d({y}vh, 0,-{z}vh)";
            this.colorstep = 255 / this.spans.length;
            this.currentIndex = 0;
            this.slideIndex = 1;
            // Initialisation
            this.step(1, -1);

            this.articleSlider(this.slideIndex);

            if ($("#next").length > 0) {
                document
                    .getElementById("next")
                    .addEventListener("click", this.Snext);
            }
            if ($("#previous").length > 0) {
                document
                    .getElementById("previous")
                    .addEventListener("click", this.Sprevious);
                // this.articleSlider(1);
            }
        }
    }

    ifElementExists = function(element) {
        if (typeof element != "undefined" && element != null) {
            return true;
        }
        return false;
    }

    step = function(dir, index) {
        let selector = "span:nth-child(n+" + (index + 2) + ")";
        if (dir < 1) {
            selector = "span:nth-child(n+" + (index + 1) + ")";
        }

        let toMove;
        if (this.ifElementExists(this.container)) {
            toMove = this.container.querySelectorAll(selector);
            toMove.forEach((v, i) => {
                let gs = Math.round(0 + this.colorstep * i);
                gs = gs > 255 ? 255 : gs;
                let z = i * 20,
                    y = i * 7;
                if (dir < 1) {
                    z = (i + 1) * 20;
                    y = (i + 1) * 7;
                }
                v.style.transform = this.transform
                    .replace("{z}", z)
                    .replace("{y}", y);
                v.style.color = "rgb(" + gs + "," + gs + "," + gs + ")";
            });
        }
    }

    Snext = (evt) => {
        if (this.currentIndex < this.spans.length - 1) {
            let c = this.getCurrentEl();
            this.slideUp(c);
            this.step(1, this.currentIndex);
            
            this.currentIndex++;
            this.slideIndex++;

            if (this.currentIndex == this.spans.length - 1) {
                document.getElementById("next").classList.add("disabled");
            }
            document.getElementById("previous").classList.remove("disabled");
            this.articleSlider(this.slideIndex);
        }
    }

    Sprevious = (evt) => {
        if (this.currentIndex > 0) {
            let c = this.getPreviousEl();
            this.slideDown(c);
            this.step(-1, this.currentIndex);
            this.currentIndex--;
            this.slideIndex--;
            document.getElementById("next").classList.remove("disabled");
            if (this.currentIndex == 0) {
                document.getElementById("previous").classList.add("disabled");
            }
            this.articleSlider(this.slideIndex);
        }
    }

    getCurrentEl = function() {
        if (this.ifElementExists(this.container)) {
            return container.querySelector(
                "span:nth-child(" + (this.currentIndex + 1) + ")"
            );
        }
    }
    
    slideUp = function(el) {
        el.style.transform = "translate3d(0,-100vh,0)";
    }

    slideDown = function(el) {
        el.style.transform = "translate3d(0,0,0)";
    }

    getPreviousEl = function() {
        if (this.ifElementExists(container)) {
            return container.querySelector(
                "span:nth-child(" + this.currentIndex + ")"
            );
        }
    }

    articleSlider = (n = 0) => {

        let i;
        this.slides = document.querySelectorAll(".articleStack .article");

        if (n > this.slides.length) {
            this.slideIndex = 1;
        }
        if (n < 1) {
            this.slideIndex = this.slides.length;
        }

        for (i = 0; i < this.slides.length; i++) {
            // this.slides[i].style.display = "none";
            this.slides[i].classList.remove("is-active");
        }
       this.slideIndex--;
       this.slides[this.slideIndex].classList.toggle("is-active");
    //    this.slides[this.slideIndex].style.display = "block";
       this.slideIndex++;
    }
}
